import { CreatePartFinderBatchEntry } from '@/api/generatedApi';
import { MAX_PART_NUMBER_LENGTH } from './partNumberValidation';

export interface ParsedPasteInput {
  acceptedEntries: CreatePartFinderBatchEntry[];
  duplicatesRemoved: number;
  emptyLines: number;
  tooLong: number;
}

export const parsePastedPartNumbers = (raw: string): ParsedPasteInput => {
  const lines = raw.split(/\r\n|\r|\n/);
  const accepted: CreatePartFinderBatchEntry[] = [];
  const seen = new Set<string>();
  let duplicates = 0;
  let empty = 0;
  let tooLong = 0;
  for (const line of lines) {
    const trimmedLine = line.trim();
    if (!trimmedLine) {
      empty += 1;
      continue;
    }
    const commaIndex = trimmedLine.indexOf(',');
    const partNumber = (commaIndex === -1 ? trimmedLine : trimmedLine.slice(0, commaIndex)).trim();
    const description = commaIndex === -1 ? undefined : trimmedLine.slice(commaIndex + 1).trim() || undefined;
    if (!partNumber) {
      empty += 1;
      continue;
    }
    if (partNumber.length > MAX_PART_NUMBER_LENGTH) {
      tooLong += 1;
      continue;
    }
    const key = partNumber.toLowerCase();
    if (seen.has(key)) {
      duplicates += 1;
      continue;
    }
    seen.add(key);
    accepted.push({ partNumber, description });
  }
  return { acceptedEntries: accepted, duplicatesRemoved: duplicates, emptyLines: empty, tooLong };
};
